import BaseShell from './BaseShell.vue';

// 判断当前是否进入 PC 大屏模式，优先兼容桌面微信、常规桌面浏览器及 iPad。
export function isPcClient() {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return false;
  }

  const ua = navigator.userAgent || '';
  // iPad 识别：旧款 UA 含 iPad；新款（iPadOS 13+）platform 为 MacIntel 且有触摸点
  const isIpad =
    /iPad/i.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  // 手机端：排除 iPad，仅匹配手机 UA
  const isMobilePhone =
    /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua) && !isIpad;

  // iPad 或桌面设备，且屏幕宽度足够时进入 PC 模式
  return !isMobilePhone && window.innerWidth >= 768;
}

export const pcNavList = [
  {
    label: '看一尘网',
    path: '/plate',
    icon: 'cluster-o',
    description: '浏览版块与最新帖子',
  },
  {
    label: '一尘盯盘',
    path: '/index',
    icon: 'bell',
    description: '管理订阅与提醒规则',
  },
  {
    label: '手机发帖',
    path: '/createPost/list',
    icon: 'edit',
    description: '查看已发内容并继续发帖',
  },
  {
    label: '个人中心',
    path: '/user',
    icon: 'manager',
    description: '账号、会员与常用入口',
  },
];

export function getPcPageMeta(route) {
  const path = (route && route.path) || '';
  const titleMap = {
    '/': {
      title: '看一尘网',
      description: '',
    },
    '/plate': {
      title: '看一尘网',
      description: '按版块查看一尘网帖子，快速进入目标品类与搜索流程。',
    },
    '/plate/list': {
      title: '版块信息',
      description: '支持按主题、作者、内容和帖子类型筛选，桌面端强化筛选与信息扫描效率。',
    },
    '/index': {
      title: '一尘盯盘',
      description: '管理自动盯盘规则',
    },
    '/user': {
      title: '个人中心',
      description: '集中查看账号状态、会员权益与常用功能入口。',
    },
    '/createPost': {
      title: '发布帖子',
      description: '',
    },
    '/createPost/list': {
      title: '我发布的帖子',
      description: '按时间查看自己发布的帖子',
    },
    '/postView': {
      title: '帖子详情',
      description: '',
    },
    '/reply': {
      title: '回复帖子',
      description: '',
    },
    '/subscribe': {
      title: '我的盯盘',
      description: '查看已配置的盯盘项目与提醒状态。',
    },
    '/follow': {
      title: '我的关注帖',
      description: '集中查看已关注帖子的最新动态。',
    },
    '/vip': {
      title: '会员中心',
      description: '保持原有购买、续费与权益说明逻辑，优化桌面端展示层级。',
    },
    '/participates': {
      title: '我参与的帖子',
      description: '',
    },
    '/score': {
      title: '帖子评分',
      description: '',
    },
    '/ratingList': {
      title: '评分列表',
      description: '',
    },
    '/promotion': {
      title: '诚邀合作',
      description: '',
    },
    '/activity': {
      title: '分享赚现金',
      description: '',
    },
    '/share': {
      title: '代理分享页',
      description: '',
    },
    '/coin': {
      title: '纪念币实时走势',
      description: '',
    },
    '/caishendao': {
      title: '一尘网财神刀买卖',
      description: '查看一尘网财神刀当日买盘、卖盘与成交数据，每10秒自动更新。',
    },
  };

  return (
    titleMap[path] || {
      title: (route && route.meta && route.meta.title) || '一尘盯盘助手',
      description: '',
    }
  );
}

// 为独立路由创建一个 PC 包装层，避免每个页面都重写一份业务代码。
export function createPcAdaptiveView(loader, options = {}) {
  if (!isPcClient()) {
    return loader;
  }

  return {
    name: options.name || 'PcAdaptiveView',
    render(h) {
      const routeMeta = getPcPageMeta(this.$route);

      return h(
        BaseShell,
        {
          props: {
            title: options.title || routeMeta.title,
            description: options.description || routeMeta.description,
            wide: options.wide !== false,
          },
        },
        [h(loader)],
      );
    },
  };
}
